import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { testimonials } from '../data/testimonials';
export function TestimonialsSection() {
  return <section className="bg-sand px-4 py-16 md:py-24" data-id="element-194" data-mp="1n00ra3zw93vo">
      <Reveal className="mx-auto max-w-6xl" data-id="element-195" data-mp="1mzitv41hwjm6">
        <div className="mx-auto mb-12 max-w-2xl text-center" data-id="element-196" data-mp="1r1dvk9nc8z0h">
          <p className="mb-4 font-note text-[10px] font-semibold tracking-[0.24em] text-sage sm:text-xs" data-id="element-197" data-mp="1qzt26ncrfm47">
            SCELTO DALLE ISTRUTTRICI
          </p>
          <h2 className="text-3xl font-bold tracking-tight text-petrol md:text-4xl" data-id="element-198" data-mp="1i17l6wmxsf5j">
            Cosa dice chi insegna già con il metodo
          </h2>
        </div>
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-199" data-mp="143iwtetnupvq">
          {testimonials.map(({
          quote,
          name,
          city
        }) => <article key={name} className="flex flex-col rounded-xl border border-line bg-white p-7 shadow-soft" data-id="element-200" data-mp="2yeo2eoob5cdp">
              <div className="flex gap-1" aria-label="Valutazione: 5 stelle su 5" data-id="element-201" data-mp="32eonut9tqnu9">
                {[1, 2, 3, 4, 5].map(star => <StarIcon key={star} className="h-4 w-4 fill-terracotta text-terracotta" aria-hidden="true" data-id="element-202" data-mp="2q314ajd4eq1a" />)}
              </div>
              <p className="mt-5 text-sm leading-relaxed text-ink" data-id="element-203" data-mp="34qm689y9ej7m">{quote}</p>
              <div className="mt-auto pt-6" data-id="element-204" data-mp="2ztcbqfw0jhcx">
                <p className="font-heading text-sm font-semibold text-petrol" data-id="element-205" data-mp="2zundyb9t8h1x">{name}</p>
                <p className="font-note text-xs text-muted" data-id="element-206" data-mp="2c4t13tphqsho">{city}</p>
              </div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}